import React, { useEffect, useCallback, useState} from 'react';
import {
    setSelectedPadEdge,
    setDrawingPadEdge,
       } from 'actions/index.js';
import {connect} from 'react-redux';

const EffectInput = ({
    setDrawingPadEdge,
    isSpeaker,
    drawingEdge,
    fx,
    pad,
    id=fx.id
}) => { 
    let _id = 'effect-input-' + id;

    const onMouseUp = useCallback((e) => {
        if (drawingEdge) {
            let {effect, rack, outputNumber} = drawingEdge;
            rack = rack || pad.effectRack;
            rack.connectNodes(effect, isSpeaker ? undefined : fx, outputNumber);
            setDrawingPadEdge(pad.subSequence.id, undefined);
        }
    }, [drawingEdge]);
    return (
        <div
          onMouseUp={onMouseUp}
          id={_id} className="effect-input"></div>);
};

const mapStateToProps = (state, props) => {
  return {
      drawingEdge: state.pads.drawingEdges[props.pad.subSequence.id]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setDrawingPadEdge: (x,y)=>dispatch(setDrawingPadEdge(x,y))     
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectInput);
